// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { fourDotsSquare16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-four-dots-square': IconFourDotsSquare;
    }
}

/**
 * The icon component for the 'fourDotsSquare' icon
 */
export class IconFourDotsSquare extends IconSvg {
    public constructor() {
        super(fourDotsSquare16X16);
    }
}

registerIconSvg('icon-four-dots-square', IconFourDotsSquare);
export const iconFourDotsSquareTag = 'nimble-icon-four-dots-square';
